import { Settings, VectorTile, WMSInfo } from '@ais-ui/websockets';
import { useSettings } from '../Settings/SettingsProvider';
import { useEffect, useState } from 'react';

export const getVectorTilesFromSettings = (
  settings: Settings
): VectorTile[] => {
  return settings && settings?.vectorTiles ? settings.vectorTiles : [];
};

export const useVectorTileSettings = (): VectorTile[] => {
  const { settings } = useSettings();

  const [vectorTiles, setVectorTiles] = useState<VectorTile[]>([]);

  useEffect(() => {
    const fetchedVectorTiles = getVectorTilesFromSettings(settings);
    setVectorTiles(fetchedVectorTiles);
  }, [settings]);

  return vectorTiles;
};

export const addVectorTileToSettings = (
  vectorTile: VectorTile,
  settings: Settings
): Settings => {
  const vectorTiles = getVectorTilesFromSettings(settings);

  const settingsToSave = {
    ...settings,
    vectorTiles: [...vectorTiles, vectorTile],
  };

  return settingsToSave;
};

export const UpdateVectorTilesToSettings = (
  updatedVectorTile: VectorTile,
  settings: Settings
): Settings => {
  const vectorTiles = getVectorTilesFromSettings(settings);

  const vectorTileIndex = vectorTiles.findIndex(
    (vectorTile) => vectorTile.id === updatedVectorTile.id
  );

  if (vectorTileIndex !== -1) {
    vectorTiles[vectorTileIndex] = updatedVectorTile;
  } else {
    return settings;
  }

  const settingsToSave = {
    ...settings,
    vectorTiles: vectorTiles,
  };

  return settingsToSave;
};

export const deleteVectorTileInSettings = (
  deletedVectorTile: VectorTile,
  settings: Settings
): Settings => {
  const vectorTiles = getVectorTilesFromSettings(settings);

  const filteredVectorTiles = vectorTiles.filter(
    (vectorTile) => vectorTile.id !== deletedVectorTile.id
  );

  const settingsToSave = {
    ...settings,
    vectorTiles: filteredVectorTiles,
  };

  return settingsToSave;
};

export const ToggleVectorTileInSettings = (
  vectorTiles: VectorTile[],
  vectorTileId: string,
  enabled: boolean,
  settings: Settings
): Settings => {
  const vectorTileIndex = vectorTiles.findIndex(
    (vectorTile) => vectorTile.id === vectorTileId
  );

  if (vectorTileIndex !== -1) {
    // Update the enabled property of the found vector tile
    vectorTiles[vectorTileIndex].enabled = enabled;
  }

  const settingsToSave = {
    ...settings,
    vectorTiles: vectorTiles,
  };

  return settingsToSave;
};
